/* eslint-disable */
import React, { useContext, useEffect, useState, useCallback, useMemo, lazy, Suspense } from 'react';
import '../../StaffAugStatusMaster/staffAugStatusMaster.scss';
import '../ReceivedRequest/receivedRequest.scss';
import { RECIEVE_REQUEST } from '../../../Constants/strings';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import EditIcon from '../../../Assets/images/svg/dar_pencil.svg';
import DisabledOpacityEditIcon from '../../../Assets/images/svg/dar_pencil_gray_opacity.svg';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import MoreActionIcon from '../../../Assets/images/svg/moreAction.svg';
import MoreActionDisabled from '../../../Assets/images/svg/moreActionDisabled.svg';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import debounce from 'lodash.debounce';
import dayjs from 'dayjs';
import { getTechSessionData, techSessionRequestApi, cancelTechSession } from '../../../Api/request/techSessions';
import UseAxios from '../../../Api/http/http';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { fetchUserDataFromZoho } from '../../../Utils/userDataUtil';
import { useNavigate } from 'react-router-dom';
import puzzleLoader from '../../../Assets/images/svg/loading puzzle.gif';

const UpdateSessionRequest = lazy(() => import('./updateSessionRequest'));
const ActionConfirmationDialog = lazy(() => import('./actionConfirmationDialog'));
import { updateLoginDetails } from '../../../Utils/userSession';

const ReceivedRequest = () => {
  const { userProfile } = useContext(AuthContext);
  const { snackbarOpen } = useSnackbar();
  const navigate = useNavigate();

  const [isMobileView, setIsMobileView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const [rows, setRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [editTechSession, setEditTechSession] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedSessionData, setSelectedSessionData] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [comments, setComments] = useState('');
  const [isApproveClicked, setIsApproveClicked] = useState(false);
  const [showCommentBox, setShowCommentBox] = useState(true);
  const [isCancelClicked, setIsCancelClicked] = useState(false);

  const content = RECIEVE_REQUEST;

  // Memoize permission check
  const permission = useMemo(() =>
    userProfile?.permissions?.[MODULE_NAMES.TECH_SESSION_RECEIVED_REQUEST] || [],
    [userProfile?.permissions]
  );

  const hasAccess = useCallback((action) => {
    return permission.includes(action);
  }, [permission]);

  const getMobileView = useCallback(() => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1200);
  }, []);

  const handleTechSessionModel = useCallback(() => setEditTechSession(false), []);

 const mapSessionToRow = useCallback((row) => {
  let audienceVertical = '-';
  let audienceDepartment = '-';

  if (Array.isArray(row.deptVerDetails) && row.deptVerDetails.length > 0) {
    const verticalNames = row.deptVerDetails
      .map(vd => vd.verticalName)
      .filter(Boolean);
    audienceVertical = verticalNames.length ? verticalNames.join(', ') : '-';

    // Updated to handle the new departmentList structure
    const departmentNames = row.deptVerDetails.flatMap(vd => {
      if (Array.isArray(vd.departmentList)) {
        return vd.departmentList.map(dept => dept.name);
      }
      return [];
    });
    audienceDepartment = departmentNames.length ? departmentNames.join(', ') : '-';
  }

  return {
    id: row.id,
    hostName: row.hostName,
    approverId: row.approverId,
    techSessionName: row.sessionName,
    topic: row.sessionTopic,
    coHost: Array.isArray(row.coHostNames) ? row.coHostNames.join(', ') : '',
    date: row.sessionDate,
    slot: row.slot,
    audienceVertical,
    audienceDepartment,
    type: row.sessionType,
    location: row.location,
    description: row.description,
    status: row.status,
    updatedAt: row.updatedAt,
    deptVerDetails: row.deptVerDetails || [],
    sessionName: row.sessionName,
    sessionTopic: row.sessionTopic,
    sessionDate: row.sessionDate,
    sessionType: row.sessionType,
    startTime: row.startTime,
    endTime: row.endTime,
    hostEmail: row.hostEmail,
    coHostNames: row.coHostNames || [],
    coHostEmail: row.coHostEmail || [],
    creatorEmail: row.creatorEmail,
    isApproved: row.isApproved,
    createdAt: row.createdAt
  };
}, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const apiConfig = getTechSessionData();
      const response = await UseAxios(apiConfig);
      const sessions = response?.data?.data?.techSessionDetails;
      if (!Array.isArray(sessions) || sessions.length === 0) {
        setRows([]);
        return;
      }
      setRows(sessions.map(mapSessionToRow));
    } catch (error) {
      console.error('Error fetching tech sessions:', error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [mapSessionToRow]);

  const getTechSession = useCallback(() => fetchData(), [fetchData]);

  const handleCloseMenu = useCallback((rowId) => {
    setAnchorEl((prev) => ({ ...prev, [rowId]: null }));
  }, []);

  // API call to approve or reject tech session request
  const approveOrRejectTechSession = useCallback(() => {
    const payload = {
      sessionId: sessionId,
      comments: comments,
      isApproved: isApproveClicked,
      isInvited: true,
      lastUpdatedBy: userProfile.user_name,
      employeeId: userProfile.employeeId,
      type: 'Admin',
    };
    setIsDialogOpen(false);
    handleCloseMenu(sessionId);

    UseAxios(techSessionRequestApi(payload))
      .then((response) => {
        if (response?.status === 200) {
          snackbarOpen(isApproveClicked ? content?.TECH_SESSION_REQUEST_APPROVED : content?.TECH_SESSION_REQUEST_REJECTED, 'success');
          setRows((prevRows) => prevRows.map((row) => {
            if (row.id === response.data.sessionId) {
              return {
                ...row,
                status: isApproveClicked ? 'Approved' : 'Rejected',
                approverId: isApproveClicked ? userProfile.employeeId : null,
              };
            }
            return row;
          }));
          fetchData();
          setComments('');
        } else {
          snackbarOpen(isApproveClicked ? content?.API_ERROR_FOR_APPROVE : content?.API_ERROR_FOR_REJECT, 'error');
        }
      })
      .catch((error) => {
        if(error?.statusCode === 403) {
          const token = localStorage.getItem('authToken');
          updateLoginDetails(token).then(() => {
            snackbarOpen('Token expired. Please login again.', 'error');
          });
        }
        snackbarOpen(isApproveClicked ? content?.API_ERROR_FOR_APPROVE : content?.API_ERROR_FOR_REJECT, 'error');
      });
  }, [sessionId, comments, isApproveClicked, userProfile, handleCloseMenu, snackbarOpen, content]);

  useEffect(() => {
    fetchData();
    getMobileView();
    const debouncedResize = debounce(getMobileView, 200);
    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
      debouncedResize.cancel && debouncedResize.cancel();
    };
  }, [fetchData, getMobileView]);

  const getColumnWidth = useCallback((mobile, laptop, defaultWidth) => {
    if (isMobileView) {
      return mobile;
    } else if (isLaptopView) {
      return laptop;
    }
    return defaultWidth;
  }, [isMobileView, isLaptopView]);

  const getColumnFlex = useCallback((defaultFlex) => {
    if (!isMobileView && !isLaptopView) {
      return defaultFlex;
    }
    return undefined;
  }, [isMobileView, isLaptopView]);

  const handleActionClick = useCallback((event, rowId) => {
    setAnchorEl((prev) => ({ ...prev, [rowId]: event.currentTarget }));
  }, []);

  // Memoize fieldsToShow to prevent recreation
  const fieldsToShow = useMemo(() => [
    'employeeId',
    'fullName',
    'emailId',
    'employeestatus',
    'photoSignedUrl',
  ], []);

  const fetchUserById = useCallback(async (name) => {
    try {
      const res = await fetchUserDataFromZoho(name, fieldsToShow);
      return res;
    } catch (error) {
      console.error('Error fetching user by ID:', error);
      return null;
    }
  }, [fieldsToShow]);

  const handleEditClick = useCallback(async (rowData) => {
    // Fetch host object
    let hostObject = null;
    if (rowData.hostName) {
      const hostRes = await fetchUserById(rowData.hostName);
      if (hostRes && hostRes.length > 0) {
        hostObject = hostRes[0];
      }
    }
    // Fetch cohost objects
    let coHostObjects = [];
    if (rowData.coHost) {
      const coHostNamesArray = rowData.coHost.split(',').map((name) => name.trim());
      const coHostResults = await Promise.all(
        coHostNamesArray.map(async (name) => {
          const res = await fetchUserById(name);
          return res?.[0];
        })
      );
      coHostObjects = coHostResults.filter(Boolean);
    }

    setSelectedSessionData({ ...rowData, hostObject, coHostObjects });
    setEditTechSession(true);
  }, [fetchUserById]);

  const cancelTechSessionRequest = useCallback(() => {
  setLoading(true);
  setIsDialogOpen(false);
  handleCloseMenu(sessionId);

  UseAxios(cancelTechSession(sessionId, true))
    .then((response) => {
      if (response?.status === 200) {
        snackbarOpen("Tech session cancelled successfully", "success");
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === sessionId ? { ...row, status: "Cancelled" } : row
          )
        );
      } else {
        snackbarOpen("Failed to cancel session", "error");
      }
    })
    .catch(() => {
      snackbarOpen("Failed to cancel session", "error");
    })
     .finally(() => {
      setLoading(false);
    });
}, [sessionId, handleCloseMenu, snackbarOpen]);

  const handleApprove = useCallback((value) => {
    setIsDialogOpen(true);
    setTitle("Approve request");
    setDescription("Are you sure you want to approve the request?");
    setButtonText("Approve");
    setIsApproveClicked(true);
    setSessionId(value);
  }, []);

  const handleReject = useCallback((value) => {
    setIsDialogOpen(true);
    setTitle("Reject request");
    setDescription("Are you sure you want to reject the request?");
    setButtonText("Reject");
    setSessionId(value);
    setIsApproveClicked(false);
  }, []);

  const handleCancelSession = useCallback((value) => {
    setIsDialogOpen(true);
    setTitle("Cancel session");
    setDescription("Are you sure you want to cancel the session?");
    setButtonText("Cancel session");
    setShowCommentBox(false);
    setIsCancelClicked(true);
    setSessionId(value);
  }, []);

  const desktopColumns = useMemo(() => [
    {
      field: content.FIELDS.HOST_NAME,
      headerName: content.HEADERS.HOST_NAME,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 195,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.TECH_SESSION_NAME,
      headerName: content.HEADERS.TECH_SESSION_NAME,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 230,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.TOPIC,
      headerName: content.HEADERS.TOPIC,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 160,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.CO_HOST,
      headerName: content.HEADERS.CO_HOST,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 150,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: 'date',
      headerName: content.HEADERS.DATE,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 130,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      showDateFilter: true,
      showTextFilter: false,
      renderCell: (params) => params.value ? dayjs(params.value).format('DD MMM, YYYY') : '',
    },
    {
      field: 'slot',
      headerName: content.HEADERS.SLOT,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 150,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.AUDIENCE_VERTICAl,
      headerName: content.HEADERS.AUDIENCE_VERTICAl,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 170,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.AUDIENCE_DEPARTMENT,
      headerName: content.HEADERS.AUDIENCE_DEPARTMENT,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 180,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.TYPE,
      headerName: content.HEADERS.TYPE,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 125,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.LOCATION,
      headerName: content.HEADERS.LOCATION,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 150,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.DESCRIPTION,
      headerName: content.HEADERS.DESCRIPTION,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 210,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.STATUS,
      headerName: content.HEADERS.STATUS,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 130,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
    },
    {
      field: content.FIELDS.ACTIONS,
      headerName: content.HEADERS.ACTIONS,
      minWidth: 100,
      width: getColumnWidth(130, 130, 100),
      flex: getColumnFlex(0.7),
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      renderCell: (params) => {
        const isMenuOpen = Boolean(anchorEl[params.row.id]);
        const isNewRequest = params?.row?.status === 'New Request' || params?.row?.status === 'Update Confirmed' ||
          params?.row?.status === 'Update Rejected';
        const isRejected = params?.row?.status === 'Rejected';
        const isCompleted = params?.row?.status === 'Completed';
        const isApproved = params?.row?.status === 'Approved';
        const isCancelled = params?.row?.status === 'Cancelled';
        const isApprover = isNewRequest || params?.row?.approverId === userProfile?.employeeId;
        const canUpdate = hasAccess('update');
        const isUpdateRequested = params?.row?.status === 'Update Requested';
        const canEdit = canUpdate && !isRejected && isApprover && !isCompleted && !isCancelled && !isUpdateRequested;
        const canMoreAction = canUpdate;
        const canDelete = hasAccess('delete');
        
        return (
          <div className="action-icons" style={actionIconsStyle}>
            <button
              id="tech-session-edit-button"
              className={canEdit ? "tech-session-edit-icon" : "tech-session-edit-icon-disabled"}
              aria-label="Edit"
              style={buttonStyle}
              onClick={() => handleEditClick(params.row)}
              disabled={!canEdit}
            >
              <img src={canEdit ? EditIcon : DisabledOpacityEditIcon} alt="editIcon" />
            </button>
            <button
              aria-label="moreAction"
              className={canMoreAction ? "tech-session-edit-icon" : "tech-session-edit-icon-disabled"}
              onClick={(event) => handleActionClick(event, params.row.id)}
              id="users-kebab-btn"
              disabled={!canMoreAction}
            >
              <img src={canMoreAction ? MoreActionIcon : MoreActionDisabled} alt="moreAction" />
            </button>
            <Menu
              anchorEl={anchorEl[params.row.id]}
              open={isMenuOpen}
              onClose={() => handleCloseMenu(params.row.id)}
              className="received-request-menu"
            >
              <MenuItem
                onClick={() => handleApprove(params.row.id)}
                className="approve-btn"
                id="edit-users-role-btn"
                disabled={isApproved || isRejected || isCancelled || isCompleted}
              >
                Approve
              </MenuItem>
              <MenuItem
                onClick={() => handleReject(params.row?.id)}
                className="reject-btn"
                id="users-profile-btn"
                disabled={isApproved || isRejected || isCancelled || isCompleted}
              >
                Reject
              </MenuItem>
              <MenuItem
                onClick={() => navigate(`/tech-session/signup?sessionId=${params.row.id}`)}
                className="reject-btn"
                id="users-view-btn"
              >
                View
              </MenuItem>
              <MenuItem
                onClick={() => handleCancelSession(params.row?.id)}
                className="reject-btn"
                id="users-profile-btn"
                disabled={!isApproved || !canDelete || isCancelled}
              >
                Cancel Session
              </MenuItem>
            </Menu>
          </div>
        );
      },
      sortable: false,
      disableColumnMenu: true,
    },
  ], [getColumnWidth, getColumnFlex, anchorEl, userProfile?.employeeId, hasAccess, handleActionClick, handleCloseMenu, handleEditClick, handleApprove, handleReject, handleCancelSession]);

  const sortFilterColumns = useMemo(() =>
    desktopColumns
      .filter((column) => column.field !== content.FIELDS.ACTIONS)
      .map((column) => column.field),
    [desktopColumns, content.FIELDS.ACTIONS]
  );

  const onPopupCancel = useCallback(() => {
    setIsDialogOpen(false);
    setSessionId(null);
    setComments('');
  }, []);

  // Memoize inline styles
  const buttonStyle = useMemo(() => ({
    background: 'none',
    border: 'none',
    padding: 0,
  }), []);

  const actionIconsStyle = useMemo(() => ({
    marginTop: '10px'
  }), []);

  const noDataStyle = useMemo(() => ({
    textAlign: 'center',
    marginTop: 20
  }), []);

  return (
    <div className="tech-session-outer-layer">
      <div className="tech-session-master">
        <div className="tech-session-status-title">{RECIEVE_REQUEST.TECH_SESSION_RECIEVE_REQUEST}</div>
        <div className="tech-session-data-grid-container">
          {loading ? (
            <div className="tech-session-loader">
              <img src={puzzleLoader} alt="Loading..." className="loader-gif" />
            </div>
          ) : (
            <>
              <DataGridComponent
                dataRows={rows}
                dataColumns={desktopColumns}
                sortFilterColumns={sortFilterColumns}
                pageSize={10}
                isFilteredRows={rows}
                isDealTransition
              />
              {rows.length === 0 && (
                <div style={noDataStyle}>No data available</div>
              )}
            </>
          )}
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <UpdateSessionRequest
            modalOpen={editTechSession}
            handleClose={handleTechSessionModel}
            getTechSession={getTechSession}
            rows={rows}
            setRows={setRows}
            sessionData={selectedSessionData}
          />
          <ActionConfirmationDialog
            open={isDialogOpen}
            title={title}
            description={description}
            button2Text={buttonText}
            onCancel={() => onPopupCancel()}
            showCommentBox={showCommentBox}
            handleApproveOrReject={() => {
              if (isCancelClicked) {
                cancelTechSessionRequest();
                setIsCancelClicked(false);
              } else {
                approveOrRejectTechSession();
              }
            }}
            setComments={(value) => setComments(value)}
            comments={comments}
          />
        </Suspense>
      </div>
    </div>
  );
};
export default ReceivedRequest;
